enum KIOSK_SETTINGS {
  RequestMoxi = 'Request Moxi',
  CancelTasks = 'Cancel Tasks',
  ShowUnrelated = 'Show Unrelated',
  ShowRobotsInService = 'Show Robots in Service',
  AutomaticRestrictedDelivery = 'Restricted Delivery: Automatic',
  RequestRestrictedDelivery = 'Restricted Delivery: Request',
  Available = 'Available',
}

export { KIOSK_SETTINGS };
